'use client';

import Link from 'next/link';
import { VIDEO_CATEGORIES } from '@/data/videos';

interface HomeFooterProps {
  onCategoryChange: (cat: string) => void;
  onSubmitVideo: () => void;
  onAdminPanel: () => void;
  onAdvertise: () => void;
}

export default function HomeFooter({ onCategoryChange, onSubmitVideo, onAdminPanel, onAdvertise }: HomeFooterProps) {
  return (
    <footer className="border-t border-stroke-primary bg-surface-secondary">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="text-text-primary font-bold text-2xl uppercase mb-3">
              VIDD<span className="text-brand-red">★</span>STAR
            </div>
            <p className="text-text-muted text-sm leading-relaxed">
              The internet&apos;s home for raw, real, and unfiltered video content. User-submitted, community-driven, admin-approved.
            </p>
          </div>
          {/* Categories */}
          <div>
            <h4 className="text-text-primary font-bold uppercase text-sm tracking-wide mb-3">Categories</h4>
            <div className="space-y-2">
              {VIDEO_CATEGORIES.slice(0, 8).map(cat => (
                <button
                  key={cat}
                  onClick={() => onCategoryChange(cat)}
                  className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150 text-left"
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
          {/* Info */}
          <div>
            <h4 className="text-text-primary font-bold uppercase text-sm tracking-wide mb-3">ViddStar Network</h4>
            <div className="space-y-2">
              <button
                onClick={() => onCategoryChange('All')}
                className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150"
              >
                📺 ViddStarTV
              </button>
              <Link href="/clips" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                ⚡ ViddStar Clips
              </Link>
              <Link href="/news" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                📰 ViddStar News
              </Link>
              <Link href="/exclusive" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                ★ ViddStar Exclusive
              </Link>
            </div>
            <div className="mt-4 pt-4 border-t border-stroke-secondary">
              <div className="space-y-2">
                <button onClick={onSubmitVideo} className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                  Submit a Video
                </button>
                <button onClick={onAdminPanel} className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                  Admin Panel
                </button>
                <Link href="/admin/video-ads" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                  Video Ads Admin
                </Link>
                <Link href="/advertiser" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                  📊 My Ad Campaigns
                </Link>
                <Link href="/ad-revenue" className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150">
                  💳 Ad Revenue & Billing
                </Link>
                <button onClick={onAdvertise} className="block text-text-muted hover:text-brand-red text-sm transition-colors duration-150 text-left">
                  📣 Advertise / Promote
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-stroke-secondary pt-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-text-muted text-xs">
            &copy; 2024 ViddStar. All rights reserved.
          </p>
          <p className="text-text-muted text-xs">
            Raw. Real. Unfiltered.
          </p>
        </div>
      </div>
    </footer>
  );
}
